import { lazy } from 'react';

// Em produção o host estático devolve o index.html com 200 pra chunk que não existe mais, então
// quem está com o painel aberto durante um deploy pede o hash antigo e recebe HTML. O reload
// busca o main.js novo, que já aponta pros chunks do build atual.
const RELOAD_GUARD_KEY = 'cakto:chunk-reload-at';
const RELOAD_GUARD_WINDOW_MS = 30 * 1000;
const CHUNK_ERROR_MESSAGE = /Loading (CSS )?chunk/;

const isChunkLoadError = (error) =>
  Boolean(error) &&
  (error.name === 'ChunkLoadError' || CHUNK_ERROR_MESSAGE.test(String(error.message)));

const readLastReloadAt = () => Number(window.sessionStorage.getItem(RELOAD_GUARD_KEY)) || 0;

// Sem storage não há como saber se a página já recarregou, e recarregar às cegas pode virar loop.
const markReload = () => {
  try {
    const now = Date.now();

    if (now - readLastReloadAt() < RELOAD_GUARD_WINDOW_MS) {
      return false;
    }

    window.sessionStorage.setItem(RELOAD_GUARD_KEY, String(now));
    return true;
  } catch (error) {
    return false;
  }
};

// Só a guarda vencida é limpa: dentro da janela, um sucesso de outro chunk (o shell de uma rota
// aninhada, cujo hash não mudou) apagaria a guarda do chunk que falhou e o reload entraria em loop.
const clearExpiredReloadGuard = () => {
  try {
    const lastReloadAt = readLastReloadAt();

    if (lastReloadAt && Date.now() - lastReloadAt >= RELOAD_GUARD_WINDOW_MS) {
      window.sessionStorage.removeItem(RELOAD_GUARD_KEY);
    }
  } catch (error) {
    // sem storage não existe guarda gravada
  }
};

export const loadWithReload = (factory) =>
  factory().then(
    (module) => {
      clearExpiredReloadGuard();
      return module;
    },
    (error) => {
      if (!isChunkLoadError(error) || !markReload()) {
        throw error;
      }

      window.location.reload();
      // Segura o Suspense no fallback até a página trocar, em vez de piscar o GlobalErrorBoundary.
      return new Promise(() => {});
    }
  );

const lazyWithReload = (factory) => lazy(() => loadWithReload(factory));

export default lazyWithReload;
